import { helper } from '@ember/component/helper';
import { htmlSafe as EmberHtmlSafe } from '@ember/template';

// This is the one `html-safe` helper to rule them all.
// It deliberately overrides the `html-safe` that `ember-cli-string-helpers`
// ships. Our version renders falsy values (0, false, NaN) where upstream
// doesn't.
export function htmlSafe([inStr]) {
  return EmberHtmlSafe(inStr);
}

export default helper(htmlSafe);
